import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { freeSet } from '@coreui/icons';
import {environment} from '../environments/environment';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>',
  providers: [IconSetService],
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    public iconSet: IconSetService
  ) {
    // iconSet singleton
    iconSet.icons = { ...freeSet };
  }
  url = '';

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    this.loadEnvironement();
  }

  loadEnvironement() {
    if (localStorage.getItem('env') === null) {
      this.url = window.location.href;
      if (this.url.includes('dev')) {
        localStorage.setItem('env', 'dev');
        environment.url = 'https://apidev.kahpoo.com/api';
        environment.url_photo = 'https://apidev.kahpoo.com/user-photos';
      } else if (this.url.includes('recette')) {
        localStorage.setItem('env', 'recette');
        environment.url = 'https://apirecette.kahpoo.com/api';
        environment.url_photo = 'https://apirecette.kahpoo.com/user-photos';
      } else if (this.url.includes('qualification')) {
        localStorage.setItem('env', 'qualification');
        environment.url = 'https://qualification.kahpoo.com/api';
        environment.url_photo = 'https://qualification.kahpoo.com/api/user-photos';
      } else if (this.url.includes('local')) {
        localStorage.setItem('env', 'local');
        environment.url = 'http://localhost:8080/api/';
        environment.url_photo = 'https://apidev.kahpoo.com/user-photos/';

      } else {
        localStorage.setItem('env', 'production');
        environment.url = 'https://www.kahpoo.com/api';
        environment.url_photo = 'https://www.kahpoo.com/user-photos';
      }
    } else {
      this.url = localStorage.getItem('env');
    }
   // console.log('url:' + environment.url);
  }
}
